import type { InternalAxiosRequestConfig } from "axios";

/**
 * When REACT_APP_AUTH_ENABLED is not 'false', sets Authorization to
 * `Bearer {Microsoft Entra access token}` from localStorage (accessToken or access_token).
 */
export function attachMicrosoftEntraBearer(
  config: InternalAxiosRequestConfig
): InternalAxiosRequestConfig {
  const authEnabled = process.env.REACT_APP_AUTH_ENABLED !== "false";
  if (!authEnabled) {
    return config;
  }
  const raw =
    localStorage.getItem("accessToken") || localStorage.getItem("access_token");
  const token = raw?.trim();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else if (config.headers.Authorization !== undefined) {
    delete config.headers.Authorization;
  }
  return config;
}
